











import Vue from 'vue';
import { DatePickerDayModel } from '../../types/datePicker';

export default Vue.extend({
  name: 'DatePickerContainer',
  props: {
    weekdays: Array,
    weeks: Array,
    rangePicker: Boolean,
    showTwoMonth: Boolean,
    sDay: Object,
    sSecondDay: Object,
    hDay: Object,
  },
  methods: {
    isInRange(day: DatePickerDayModel): boolean {
      if (!this.rangePicker || !day.date) {
        return false;
      }
      if (this.sDay) {
        if (this.sSecondDay) {
          return day.date.isAfter(this.sDay.date, 'day') && day.date.isBefore(this.sSecondDay.date, 'day');
        } else if (this.hDay) {
          return (
            (day.date.isAfter(this.sDay.date, 'day') && day.date.isBefore(this.hDay.date, 'day')) ||
            (day.date.isBefore(this.sDay.date, 'day') && day.date.isAfter(this.hDay.date, 'day'))
          );
        }
      }
      return false;
    },
    dayClass(day: DatePickerDayModel): any {
      return {
        mute: !day.currentM || day.disabled,
        today: day.today,
        selected: day.selected,
        'in-range': this.isInRange(day),
      };
    },
    selectDay(day: DatePickerDayModel): void {
      if (!day.disabled) {
        this.$emit('selectDay', day);
      }
    },
    hoverDay(day: DatePickerDayModel) {
      if (!day.disabled) {
        this.$emit('hoverDay', day);
      }
    },
  },
});
